var React = require('react');

function MinusOctagon (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M497.9 150.5L361.4 14.1A48 48 0 0 0 327.5 0H184.4a48 48 0 0 0-33.9 14.1L14.1 150.6A48 48 0 0 0 0 184.5v143.1a48 48 0 0 0 14.1 33.9l136.5 136.4a48 48 0 0 0 33.9 14.1h143.1a48 48 0 0 0 33.9-14.1l136.4-136.5a48 48 0 0 0 14.1-33.9V184.4a48 48 0 0 0-14.1-33.9zM400 284a12 12 0 0 1-12 12H124a12 12 0 0 1-12-12v-56a12 12 0 0 1 12-12h264a12 12 0 0 1 12 12z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M400 228v56a12 12 0 0 1-12 12H124a12 12 0 0 1-12-12v-56a12 12 0 0 1 12-12h264a12 12 0 0 1 12 12z","className":"fa-primary","key":2})]);
}

MinusOctagon.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = MinusOctagon;

MinusOctagon.default = MinusOctagon;
